"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _MenuNavigationItem = _interopRequireDefault(require("./MenuNavigationItem"));

var _default = function _default(_ref) {
  var categories = _ref.categories,
      displayCategoriesAs = _ref.displayCategoriesAs,
      showMenuNavigation = _ref.showMenuNavigation,
      menuNavigationDivided = _ref.menuNavigationDivided;
  return showMenuNavigation && _react["default"].createElement(_semanticUiReact.Grid, {
    divided: menuNavigationDivided,
    columns: categories.length,
    style: {
      textAlign: 'center',
      marginBottom: '3em',
      marginLeft: '3em',
      marginRight: '3em'
    },
    stackable: true
  }, categories.map(function (category) {
    return _react["default"].createElement(_semanticUiReact.Grid.Column, {
      key: category
    }, _react["default"].createElement(_MenuNavigationItem["default"], {
      category: category,
      displayCategoriesAs: displayCategoriesAs
    }));
  }));
};

exports["default"] = _default;